import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "漫画分类",
    links: [
      { name: "武侠漫画", href: "/category/wuxia" },
      { name: "奇幻漫画", href: "/category/fantasy" },
      { name: "恋爱漫画", href: "/category/romance" },
      { name: "悬疑漫画", href: "/category/suspense" },
    ],
  },
  {
    title: "热门推荐",
    links: [
      { name: "剑尊归来", href: "/article/1" },
      { name: "全知读者视角", href: "/article/2" },
      { name: "我独自升级", href: "/article/3" },
      { name: "神之塔", href: "/article/6" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { name: "品牌故事", href: "/about" },
      { name: "联系我们", href: "/about" },
      { name: "常见问题", href: "/about" },
      { name: "用户协议", href: "/about" },
    ],
  },
  {
    title: "帮助支持",
    links: [
      { name: "阅读指南", href: "/about" },
      { name: "意见反馈", href: "/about" },
      { name: "加入我们", href: "/about" },
      { name: "友情链接", href: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-white mb-5 whitespace-nowrap">
                {col.title}
              </h4>
              <div className="w-8 h-px bg-primary-500/50 mb-4"></div>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-300 hover:text-white transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 md:mt-20 pt-10 border-t border-foreground-800/50">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <div
                className="text-4xl md:text-5xl font-black text-white mb-2"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                韩漫网
              </div>
              <p className="text-xs text-foreground-400">
                高清韩国漫画免费在线阅读平台
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-8">
              <p className="text-xs text-foreground-400 whitespace-nowrap">
                &copy; 2026 韩漫网 hongtongren.com 版权所有。
              </p>
              <div className="flex items-center gap-4">
                <Link
                  to="/about"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 hover:bg-primary-500 transition-colors duration-200"
                  aria-label="关于我们"
                >
                  <i className="ri-information-line text-base text-white"></i>
                </Link>
                <Link
                  to="/category/romance"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 hover:bg-primary-500 transition-colors duration-200"
                  aria-label="恋爱漫画"
                >
                  <i className="ri-heart-line text-base text-white"></i>
                </Link>
                <Link
                  to="/category/fantasy"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 hover:bg-primary-500 transition-colors duration-200"
                  aria-label="奇幻漫画"
                >
                  <i className="ri-sparkling-line text-base text-white"></i>
                </Link>
                <a
                  href="mailto:hello@hongtongren.com"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800/50 hover:bg-primary-500 transition-colors duration-200"
                  aria-label="联系邮箱"
                >
                  <i className="ri-mail-line text-base text-white"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
